import BranchComponent from "./Branch.container";

export default BranchComponent;
